import axios from "axios";
import { Dialog } from "vant";

let baseURL = process.env.VUE_APP_BASE_API; //'http://10.20.42.51:8088'
const services = axios.create({
  baseURL,
  timeout: 1000 * 10 * 6,
});
services.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code != 0) {
      Dialog({ message: res.msg || "请求出错了" });
      return Promise.reject(res);
    }
    return res;
  },
  (error) => {
    Dialog({ message: "请求网络失败！" });
    return Promise.reject(error);
  }
);
export default services;
